import * as angular from 'angular';

import { ComponentDefinition, TagDefinition } from '../../models/index';
import { IStoreService } from '../../services';

class TagsManagementState implements angular.IComponentController {
    
    static $inject = ['storeService'];

    constructor(
        private _storeService: IStoreService,
    ) {
    }

    onUpdate(updated: TagDefinition[]) {
        this._storeService.dispatchers().tags.getAll(true);
        this._storeService.dispatchers().valueViewModels.getAll(true);
    }
}

export const wtTagsManagementState: ComponentDefinition = {
    componentId: 'wtTagsManagementState',
    controller: TagsManagementState,
    template: require('./tagsManagement.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};